module.exports = __webpack_public_path__ + "img/golfpractice_bodyimage04.659d4744.jpg";